var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card-panel-text"},[_vm._v("完成消项整改百分比")]),_c('dv-water-level-pond',{staticStyle:{"width":"200px","height":"300px"},attrs:{"config":_vm.config}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }